<template>
  <v-col cols="12" md="6" sm="12" xs="12">
    <v-autocomplete density="compact" v-model="form.copier.lease_term" :items="custom_list" label="Choose Lease Term"
      variant="outlined">
    </v-autocomplete>
  </v-col>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { lease_terms, form } = storeToRefs(store)

const custom_list = computed(() => {
  const list: any[] = []
  lease_terms.value.forEach((lease_term: any) => {
    list.push({
      value: +lease_term.term,
      title: lease_term.title
    })
  })
  return list
})
</script>
